export { CouponWidgetContent } from './coupon-widget-content';
export type { CouponWidgetContentProps } from './coupon-widget-content.types';
